module.exports = __webpack_public_path__ + "assets/search-979c7d.svg";